// extracted by mini-css-extract-plugin
export var list = "projects-module--list--JVTpE";
export var item = "projects-module--item--fJMkx";
export var title = "projects-module--title--kEP3O";
export var desc = "projects-module--desc--exhvo";